/**
 * @desc: 交易规则设置
 * @created: 2020/5/22
 * @author: Colorfule
 * @version: v1.0
 */

import * as Models from '@/api/T3/tradingRulesSetting'

export default {
  namespaced: true,
  actions: {
    getListData(ctx, payload) {
      return Models.getListData(payload).then(res => {
        return (res && res.status === 200 && res.data) || []
      })
    },

    getCreateIdList(ctx, payload) {
      return Models.getCreateIdList(payload).then(res => {
        if (res.status === 200) {
          const data = [{ value: '', label: '全部' }]
          const filterData = res.data.map(elem => {
            const buffer = {}
            buffer.value = elem.id
            buffer.label = elem.username
            return buffer
          })

          return data.concat(filterData)
        } else {
          return []
        }
      })
    },

    getBriefOption(ctx, payload) {
      return Models.getBriefOption(payload).then(res => {
        if (res.status === 200) {
          return res.data.map(elem => {
            const buffer = {}

            buffer.value = elem.axis
            buffer.label = elem.ruleBrief
            return buffer
          })
        } else {
          return []
        }
      })
    },

    postCreateRules(ctx, payload) {
      return Models.postCreateRules(payload)
    },

    getCurrentRisk(ctx, payload) {
      return Models.getCurrentRisk(payload).then(res => {
        return (res && res.status === 200 && res.data) || {}
      })
    },

    postUpdateRules(ctx, payload) {
      return Models.postUpdateRules(payload)
    },

    getRiskRuleAxis(ctx, payload) {
      return Models.getRiskRuleAxis(payload).then(res => {
        const buffer = {}

        if (res.status === 200 && res.data) {
          res.data.forEach(item => {
            buffer[item.axis] = item.ruleBrief
          })
        }

        return buffer
      })
    },

    getListBlackRelease(ctx, payload) {
      return Models.getListBlackRelease(payload).then(res => {
        const buffer = [{ value: '', label: '无' }]

        if (res && res.status === 200 && res.data) {
          for (let key in res.data) {
            buffer.push({
              label: res.data[key],
              value: key
            })
          }
        }

        return buffer
      })
    }
  }
}
